<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M484.9 72.9v366.2c0 12.6-13.3 22.9-29.9 22.9H335.7v-62.6h72.6c5.9 0 11.6-1.8 15.7-5s6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1-4.2-3.2-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5s6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1-4.2-3.2-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5 4.2-3.2 6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1s-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5 4.2-3.2 6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1s-9.8-5-15.7-5h-72.6V50H455c16.5 0 29.9 10.2 29.9 22.9z" fill="#e6e6e6" />
      <path d="M44.2 47.2 294.7 6.1c2.9-.5 5.7.5 7.9 2.7s3.4 5.3 3.4 8.6v477.1c0 3.3-1.2 6.5-3.4 8.6-2.2 2.2-5 3.2-7.9 2.7l-250.4-41c-9.8-1.6-17.1-11.3-17.1-22.7V69.9c-.1-11.4 7.2-21.1 17-22.7z" fill="#0087f3" />
      <path d="M141.6 210.2z" fill="#f05264" />
      <path d="M430.6 375.5v6.8c0 4.5-2.3 8.9-6.5 12.1s-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.5 6.5 12.1zm0-82v6.8c0 4.5-2.3 8.9-6.5 12.1s-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5 4.1 3.3 6.5 7.6 6.5 12.1zm0-81.9v6.8c0 4.5-2.3 8.9-6.5 12.1-4.2 3.2-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.6 6.5 12.1zm0-81.9v6.8c0 4.5-2.3 8.9-6.5 12.1-4.2 3.2-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.6 6.5 12.1z" fill="#b8b8b8" />
      <path d="m267.4 158.9-24.8 119.2c-5.3 25.4-10.7 51-15.8 76.4-.7 3.6-2.1 4.8-5.4 4.3-10-.9-20.1-1.6-30.1-2.1-2.9 0-4.1-1.5-4.6-4.5-8.5-44.5-17.2-89.1-25.9-134-1 1.1-1.6 2.6-1.7 4.2-8.1 42-16.3 84-24.4 126 0 3.6-1.7 4.3-5 4-8.8-.7-17.7-1.2-26.5-1.7-3.4 0-5-1.2-5.7-5.2C87 287.7 76.4 229.8 65.7 172c-.7-3.9 0-4.6 3.6-4.8 7.7 0 15.2-.7 23-1.7 3.4 0 4.6 0 5.2 4.3 3.7 26.2 7.8 52.3 11.7 78.5 2.5 16.2 4.9 32.5 7.2 48.7-.6 1.3-.6 2.7 0 4 1.6 1.9 1.3 0 1.4-.9 8.7-44.3 17.4-88.6 26.1-133 .7-3.9 1.9-5.4 5.9-5.4 8.5 0 17-.9 25.4-1.8 3.5 0 4.6 0 5.3 4.5 8.4 44.8 16.8 89.5 25.4 134 0 1.7.8 3.1 1.5 6.1 4.7-29.8 9.4-58.1 14-86.4 3.2-19.6 6.3-39.1 9.4-59.6 0-2.4 1.1-3.6 3.5-3.6 9.9 0 19.6-1.2 29.5-2.1 4 .5 4.1 2.7 3.6 6.1zm0 0z" fill="#fff" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
